import React from "react";

const TESTIMONIALS = [
  { quote: "We needed a guitarist for Friday night and found the right fit without calling ten different people.", who: "Café Owner · Jaipur" },
  { quote: "Booked a sunset DJ set for our rooftop launch — application to confirmation in under 48 hours.", who: "Event Organizer · Mumbai" },
  { quote: "Direct requests from real venues in my city. No spam, no cold DMs.", who: "Independent Musician · Delhi" },
  { quote: "Our band picked up three concert dates in the first month. Everything happens on one dashboard.", who: "Indie Band · Bengaluru" },
  { quote: "Perfect for weddings — the PA info and budget are upfront, so we only apply where it fits.", who: "Wedding Band · Mumbai" },
  { quote: "Cleaner than a group chat and faster than emails. Applications keep the workflow honest.", who: "DJ · Goa" },
  { quote: "Contact stays private until we accept — no unsolicited messages to our venue phone.", who: "Live Music Venue · Delhi" },
];

export default function TestimonialMarquee() {
  const items = [...TESTIMONIALS, ...TESTIMONIALS]; // duplicate for seamless loop
  return (
    <section className="border-y border-slate-200 bg-slate-50 py-14 overflow-hidden" data-testid="testimonial-marquee">
      <div className="max-w-7xl mx-auto px-6 mb-8">
        <h2 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight">What people say</h2>
        <p className="text-slate-600 text-sm mt-1">Illustrative feedback from marketplace scenarios.</p>
      </div>
      <div className="relative marquee-mask">
        <div className="marquee flex gap-4 w-max">
          {items.map((t, i) => (
            <figure key={i} className="w-[320px] flex-none bg-white border border-slate-200 rounded-xl p-5 shadow-sm">
              <blockquote className="text-sm text-slate-800 leading-relaxed">"{t.quote}"</blockquote>
              <figcaption className="mt-3 text-xs text-slate-500 uppercase tracking-wider">{t.who}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
